import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Iconify from "../../../components/ui/iconify/Iconify";
import "./SidebarModel.scss";

const SidebarModal = ({
  modalTitle,
  onClose,
  isOpen,
  showToggle,
  children,
  defaultPosition = "right",
  modalSize = "w-45", // default width class
  ...props
}) => {
  const [isRightPosition, setIsRightPosition] = useState(
    defaultPosition === "right"
  );

  const calculateDynamicPosition = useMemo(() => {
    const classWidth = modalSize.split("-")[1]; // Extracting the numeric width value from class (e.g., "w-46" becomes "46")
    const percentage = classWidth ? parseInt(classWidth) : 40; // Default to 40% if no width is provided
    return percentage;
  }, [modalSize]);

  useEffect(() => {
    // Update position when `defaultPosition` prop changes
    setIsRightPosition(defaultPosition === "right");
  }, [defaultPosition]);

  const handleTogglePosition = () => {
    setIsRightPosition((prev) => !prev);
  };

  // Calculate the remaining percentage for left or right
  const remainingPosition = 100 - calculateDynamicPosition;

  return (
    <>
      {isOpen && (
        <div className="sidebar-modal-backdrop" onClick={onClose}></div>
      )}
      <div
        className={`sidebar-modal ${isOpen ? "open" : ""} ${modalSize} ${
          isRightPosition ? "right-position" : "left-position"
        }`}
        style={{
          width: `${calculateDynamicPosition}%`, // Dynamic width
          left: isRightPosition ? `${remainingPosition}%` : "0", // Adjust left dynamically
          right: isRightPosition ? "0" : `${remainingPosition}%`, // Adjust right dynamically
        }}
      >
        <div className="sidebar-modal-header">
          <h2>{modalTitle}</h2>
          {showToggle && (
            <div className="toggle-switch-wrapper">
              <span className="toggle-label">
                {isRightPosition ? "Move to Left" : "Move to Right"}
              </span>
              <div
                className={`toggle-switch ${isRightPosition ? "active" : ""}`}
                onClick={handleTogglePosition}
              />
            </div>
          )}
          <button className="close-button" onClick={onClose}>
            <Iconify icon="lets-icons:close-round" width={25} />
          </button>
        </div>
        <div className="sidebar-modal-content">{children}</div>
      </div>
    </>
  );
};

SidebarModal.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  modalSize: PropTypes.string, // Accepts width class like 'w-46', 'w-40', etc.
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node, // Accepts any valid React node as children
};

export default SidebarModal;
